import { render, staticRenderFns } from "./purchaseCode.vue?vue&type=template&id=0bb1f2ea"
import script from "./purchaseCode.vue?vue&type=script&lang=js"
export * from "./purchaseCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports